<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/">商城</router-link> |
      <router-link to="/cart">購物車</router-link>
    </div>-->
    <router-view />
    <br />
    <br />
  </div>
</template>

<script>
export default {
  activated() {
    //   this.$liff.init(function () {})
    //   this.$liff.getProfile().then(function () {
    //     //alert('getting profile: ' + JSON.stringify(profile))
    //   }).catch(function (error) {
    //     alert('Error getting profile: ' + error)
    //   })
  },
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

/* Toast 視窗正中央樣式 */
.notices {
  justify-content: center !important;
  align-items: center !important;
}

.notices .toast {
  min-width: 250px !important;
  max-width: 90% !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25) !important;
  animation: toast-center-in 0.3s ease-out !important;
}

@keyframes toast-center-in {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
